import { combineReducers } from "redux"
import phinExtractsReducer from "./phin"
import consultantEmailsReducer, {
	ConsultantEmailsState
} from "./consultantemails/reducer"
import consultantMonthlyPatientScoreReducer from "./consultantmonthlypatientscore/reducer"
import finalExtractReducer from "./final/reducer"
import ExtractState from "../../models/ExtractState"
import { PhinExtractsState } from "./phin/reducer"
import uriExtractReducer from "./uri/reducer"

export interface ExtractsState {
	consultantEmails: ConsultantEmailsState
	consultantMonthlyPatientScore: ExtractState
	final: ExtractState
	nhsEngland: ExtractState
	phin: PhinExtractsState
	uri: {
		surveyAnswer: ExtractState
		adhoc: ExtractState
	}
}

const extractsReducer = combineReducers({
	consultantEmails: consultantEmailsReducer,
	consultantMonthlyPatientScore: consultantMonthlyPatientScoreReducer,
	final: finalExtractReducer,
	phin: phinExtractsReducer,
	uri: uriExtractReducer
})

export default extractsReducer
